$(function() {

    // パートナーの声をモーダル表示
    $('.top-partner-voice-link').on('click',function() {
        let thisObj = $(this);
        let modalObj = $(thisObj.data("target"));

        let nameObj = $(thisObj.data("name"));
        let commentObj = $(thisObj.data("comment"));
        let nameTxt = nameObj.text();
        let commentTxt = commentObj.html();

        modalObj.find('.partner-name').text(nameTxt);
        modalObj.find('.partner-comment').html(commentTxt);

        modalObj.modal();
		return false;
    });

    // パートナーの声のモーダルを閉じる
    $('#partner-voice-close-link').on('click',function() {
        let thisObj = $(this);
        let modalObj = $(thisObj.data("target"));

		modalObj.modal('hide');
		return false;
    });


});